import {
  DateInput,
  FormInput,
  Grid,
  RadioGroupInput,
  FormGetter,
  FormSetter,
} from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Typography, Divider, Paper } from '@mui/material';
import React, { useContext } from 'react';

import { FormButton } from 'components/FormButton';
import { WebFormContext } from 'contexts/WebFormContext';

import { StepWrapper } from '../StepWrapper';

type ChildInfo = {
  voornaam: string;
  naam: string;
  geboortedatum: string;
  fiscaalCoOuderschap: string;
};

export default function Step() {
  return (
    <StepWrapper
      name="Kinderen ten laste"
      description="Typ hieronder de gegevens van de kinderen ten laste (indien correct druk op 'volgende')"
      maxWidth={1000}
    >
      <FormGetter
        names={['children']}
        render={({ children = [] }) => (
          <Grid container spacing={0}>
            <Grid xs={12}>
              <FormSetter
                render={(setValue) => (
                  <FormButton
                    variant="outlined"
                    onClick={() => {
                      setValue('children', [
                        ...children,
                        {
                          voornaam: '',
                          naam: '',
                          geboortedatum: '',
                          fiscaalCoOuderschap: '',
                        },
                      ]);
                    }}
                    startIcon={<AddIcon />}
                  >
                    Kind toevoegen
                  </FormButton>
                )}
              />
            </Grid>

            {children.map((child: ChildInfo, index: number) => (
              <Grid xs={12} key={index}>
                <Paper
                  elevation={1}
                  sx={{
                    p: 3,
                    mt: 2,
                    backgroundColor: 'rgba(0, 0, 0, 0.02)',
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <Typography variant="h6" color="primary">
                      Kind {index + 1}
                    </Typography>
                    <FormSetter
                      render={(setValue) => (
                        <FormButton
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => {
                            const newChildren = [...children];
                            newChildren.splice(index, 1);
                            setValue('children', newChildren);
                          }}
                          startIcon={<DeleteIcon />}
                        >
                          Verwijderen
                        </FormButton>
                      )}
                    />
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Grid container spacing={2}>
                    <FormInput
                      name={`children.${index}.voornaam`}
                      label="Voornaam"
                      xs={12}
                      sm={6}
                      required
                    />
                    <FormInput
                      name={`children.${index}.naam`}
                      label="Naam"
                      xs={12}
                      sm={6}
                      required
                    />
                    <DateInput
                      name={`children.${index}.geboortedatum`}
                      label="Geboortedatum"
                      xs={12}
                      sm={6}
                      required
                    />
                    <RadioGroupInput
                      name={`children.${index}.fiscaalCoOuderschap`}
                      label="Fiscaal co-ouderschap"
                      items={[
                        { text: 'Nee', value: 'nee' },
                        { text: 'Ja', value: 'ja' },
                      ]}
                      xs={12}
                      sm={6}
                      required
                    />
                  </Grid>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}
      />
    </StepWrapper>
  );
}
